module.exports = __webpack_public_path__ + "4c5490f19a21e83780da507a33433955.svg";